export interface FeatureUsage {
  limit: number;
  used: number;
}

export interface CurrentUsageFeaturesPlan {
  [featureName: string]: FeatureUsage;
}

export interface Subscription {
  id: string;
  status: string;
  planId: string;
  planName: string;
  planCode: string;
  currentPeriodStart: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  effectiveUntil: string | null;
  canReactivate: boolean;
  cancellationRequestedAt: string | null;
  provider: string;
  providerSubscriptionId: string;
}

export interface EntitlementsError {
  message: string;
  statusCode?: number;
}

export interface EntitlementsState {
  currentUsageFeaturesPlan: CurrentUsageFeaturesPlan;
  subscription: Subscription | null;
  loading: boolean;
  subscriptionActionLoading: boolean;
  error: EntitlementsError | null;
}

export interface EntitlementResponse {
  error?: boolean;
  msg?: string;
  data: {
    entitlements: {
      currentUsage: {
        featureName: string;
        limit: number;
        used: number;
      }[];
    };
    subscription: Subscription;
  };
}
